import React, { Component } from 'react';
import cx from 'classnames';

// Constants
import TranslatedCopy from '../../intl/translated-copy';
import { getCMSUrl } from '../../constants/cms-urls';

class FooterLegal extends Component {
  static defaultProps = {
    isThemedBackground: false,
    isWhiteBackground: false,
    theme: 'blue',
  }

  render() {
    const {
      hideMenuList,
      isThemedBackground,
      isWhiteBackground,
      theme,
    } = this.props;

    const footerClasses = cx(
      'FooterLegal',
      `FooterLegal--${theme}`,
      {
        'FooterLegal--isThemedBackground': isThemedBackground,
        'FooterLegal--isWhiteBackground': isWhiteBackground,
      },
    );

    if (isWhiteBackground) {
      return (
        <footer className={ !hideMenuList ? footerClasses : 'footer-no-menu-container' } role='contentinfo'>
          { hideMenuList ? this.renderFooterWithoutMenu() : this.renderFooterLegalContent() }
        </footer>
      );
    } else {
      return (
        <div className={ !hideMenuList ? footerClasses : 'footer-no-menu-container' }>
          { hideMenuList ? this.renderFooterWithoutMenu() :  this.renderFooterLegalContent() }
        </div>
      );
    }
  }

  renderFooterLegalContent() {
    const {
      country,
      language,
    } = this.props;

    const date = new Date();
    const yearNow = date.getFullYear();

    return (
      <div className='FooterLegal-wrapper'>
        <div className='FooterLegal-infoListWrapper'>
          <ul className='FooterLegal-infoList'>
            <li className='FooterLegal-infoItem'>&copy; { yearNow } Aeroméxico. <TranslatedCopy copyID='APP_ALL_RIGHTS_RESERVED' /></li>
            <li className='FooterLegal-infoItem'>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href={ getCMSUrl(country, language, 'LEGAL') }>
                <TranslatedCopy copyID='APP_LEGAL' />
              </a>
            </li>
            <li className='FooterLegal-infoItem'>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href={ getCMSUrl(country, language, 'LEGAL') }>
                <TranslatedCopy copyID='APP_PRIVACY_POLICY' />
              </a>
            </li>
            <li className='FooterLegal-infoItem'>
              <a
                target='_blank'
                rel='noopener noreferrer'
                href={ getCMSUrl(country, language, 'LEGAL') }>
                <TranslatedCopy copyID='APP_TERMS_AND_CONDITIONS' />
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }

  renderFooterWithoutMenu() {
    const date = new Date();
    const yearNow = date.getFullYear();

    return (
      <div className='footer-no-menu-wrapper'>
        <div className='copy-rights'>
          <span className='copy-rights-content'>{ yearNow } Aeroméxico. <TranslatedCopy copyID='APP_ALL_RIGHTS_RESERVED' /></span>
        </div>
        <div className='certified-by'>
          <TranslatedCopy className='copy-certified-content' copyID='MYB_CERTIFIED_BY_W_PROTECTION' />
          <div className='certified-image' />
        </div>
      </div>
    );
  }
}

export default FooterLegal;
